"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MainMenu = ({
  small,
  children,
  ...props
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NavWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Wrapper, {
      small: small,
      role: "menu",
      ...props,
      children: children
    })
  });
};
var _default = exports.default = MainMenu;